module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_1_1_2.ea361158.png";